import { gql } from "@apollo/client";

export const listCodeGroups = gql`
  query ListCodeGroups($filter: CodeGroupFilter) {
    listCodeGroups(filter: $filter) {
      codeGroupId
      codesUsedCount
      category
      codesGeneratedCount
      administrationStatus
      compositeStatus
      lifecycleStatus
      creationType
      exportUrl
      exportFile
      basicSetup {
        codeGroupName
        codeActiveStartDate
        codeActiveEndDate
      }
      producerPackaging {
        producerCompany
        codesPrintedCount
        brand
      }
      codeSpecifications {
        codeLength
        excludeCharacters
        excludeCharacterValues
      }
    }
  }
`;

export const loadCodeGroup = gql`
  query LoadCodeGroup($id: ID!) {
    loadCodeGroup(id: $id) {
      codeGroupId
      exportUrl
      codesGeneratedCount
      administrationStatus
      compositeStatus
      lifecycleStatus
      category
      basicSetup {
        codeGroupName
        codeActiveStartDate
        codeActiveEndDate
      }
      producerPackaging {
        brand
        producerCompany
        codesPrintedCount
        productVolume
        packageType
        productCapColor
      }
      dummyCodes {
        allowDummyCodes
        dummyCodeMessage
        dummyCodePercent
      }
      codeSpecifications {
        codeLength
        usePrefix
        prefixVal
        useSuffix
        suffixVal
        caseSensitive
        excludeCharacters
        excludeCharacterValues
      }
      fileDetails {
        id
        name
        size
        type
        programId
        codeGroupId
        fileMetaData {
          description
          containerName
          uploadedBy
          uploadedAt
        }
      }
    }
  }
`;
